import { render } from "./ProductAvailabilityCard.vue?vue&type=template&id=00b108f6&scoped=true"
import script from "./ProductAvailabilityCard.vue?vue&type=script&lang=js"
export * from "./ProductAvailabilityCard.vue?vue&type=script&lang=js"

import "./ProductAvailabilityCard.vue?vue&type=style&index=0&id=00b108f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b108f6"]])

export default __exports__